<template>
  <div class="app-wrapper">
    <div class="md:vertical-layout">
      <!-- Чаты скроллятся внутри себя, поэтому им нужна фиксированная высота экрана -->
      <div class="page-with-top-panel flex flex-col min-h-dvh" :class="{ 'h-dvh': route.name === 'dialogs' }">
        <AppHeader v-if="showServiceHeader" />
        <div
          class="page-self flex-grow flex md:mb-0 bg-bgnew"
          :class="{
            'max-md:!pt-12 md:!pt-20': showServiceHeader,
            'overflow-hidden': route.name === 'dialogs',
            'ml-[73px]': isMounted && isAuth && isDesktop,
            'max-md:!pb-[90px]': isMounted && basket.length > 0 && route.name !== 'dialogs' && isDesktop,
            'max-md:pb-[58px]': isMounted && isAuth && !isDesktop && route.name !== 'index',
          }"
        >
          <MenuPanelSide>
            <MenuSocialJet />
            <template #menu>
              <MenuSide />
            </template>
            <template #links>
              <MenuLinks />
            </template>
          </MenuPanelSide>
          <!-- основной слот для страницы -->
          <slot></slot>
        </div>
      </div>
    </div>

    <Teleport to="body">
      <ElDialog
        v-model="userModule.loginDialogVisible"
        class="wrapper-dialog flex justify-center md:max-w-[496px] max-md:!max-w-[96%] !mx-auto !w-full"
      >
        <LoginScreen />
      </ElDialog>
    </Teleport>

    <!-- Debug панель для Telegram WebView -->
    <TelegramDebugPanel />

    <!-- Мобильное меню внизу экрана -->
    <AdvertiserMobileBottomNav />
  </div>
</template>
<script setup lang="ts">
  import { ApiKey } from "~/common/API/baseApi";
  import { useScreenSize } from "@/helpers/isMobile";
  import { useUserStore } from "~/store/UserModule";
  import BasketService from "~/services/BasketService";
  import { useBasketStore } from "~/store/BasketModule";

  const basketStore = useBasketStore();
  const { basket } = storeToRefs(basketStore);

  const userModule = useUserStore();

  /* eslint-disable no-undef */
  const route = useRoute();

  watch(
    () => route.name,
    () => {
      nextTick(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    }
  );
  const { isDesktop } = useScreenSize();

  // const isAuth = computed(() => ApiKey.get());
  const isAuth = computed(() => userModule.authorized);

  // На публичной витрине (/s/[url]) шапку сервиса скрываем для неавторизованных
  const isShowcasePage = computed(() => route.name === "s-url");
  const showServiceHeader = computed(() => !isShowcasePage.value || isAuth.value);

  // ВАЖНО для SSR/гидрации: не трогаем localStorage до гидрации.
  onMounted(() => {
    userModule.requestAuthKey();
  });

  const isMounted = ref(false);

  const getBasket = () => {
    const basketData = BasketService.getBasket();
    if (basketData) {
      const places = basketData.places;
      if (places) {
        places.forEach((place: any) => {
          if (!("quantity" in place)) place.quantity = 1;
          if (!("format" in place)) place.format = null;
        });
        basket.value = places;
      } else {
        basket.value = [];
      }
    }
  };

  onMounted(() => {
    getBasket();
    basketStore.getDraftStatus();
    basketStore.getDraftId();
    isMounted.value = true;
  });
</script>

<style lang="scss">
  .app-wrapper {
    min-height: 100dvh;
  }

  .vertical-layout {
    display: flex;
    flex-direction: row;
    min-height: 100dvh;
  }

  .page-with-top-panel {
    flex-grow: 1;

    @media (max-width: 1230px) {
      margin-left: 0;
    }
  }

  .gorizontal-menu,
  .vertical-menu {
    background: $white;
  }

  .el-menu + .screen-wrapper {
    margin-left: 70px;

    @media (max-width: $small-width) {
      margin-left: 0;
    }
  }

  .gorizontal-menu {
    @apply w-full px-5 z-50;
    height: 80px;

    &__aside {
      @apply h-full justify-end;

      &-user {
        width: fit-content;
        color: $light-gray;
        font-weight: 500;
      }

      &-notifications {
        width: fit-content;
        height: 100%;
        padding-left: clamp(20px, 2vw, 24px);
        padding-right: clamp(20px, 2vw, 24px);
        border-left: 1px solid rgba($main, 0.3);
        border-right: 1px solid rgba($main, 0.3);

        @media (max-width: $small-width) {
          border: none;
        }
      }
    }

    &__button {
      cursor: pointer;
      margin: 6px 0px;
      width: 36px;
      height: 36px;
      border-radius: 11px;
      border: 1px solid rgba($main, 0.2);
      flex-direction: column;
      gap: 5px;
      padding-left: 8px;
      padding-right: 8px;

      > div {
        width: 100%;
        height: 2px;
        background: $main;
        border-radius: 1px;
      }
    }
  }

  .gorizontal-menu .gorizontal-menu__button {
    display: none;
  }

  @media (max-width: $small-width) {
    .app-wrapper .vertical-menu.vertical-menu.el-menu--collapse {
      border-right: none;

      &:not(.horizontal-collapse-transition) {
        transform: translateX(-300px);
      }

      img {
        display: none;
      }
    }

    .gorizontal-menu .gorizontal-menu__button {
      display: flex;

      + a {
        z-index: 1;
      }
    }

    .gorizontal-menu {
      justify-content: space-between;
    }

    @keyframes close {
      to {
        transform: translateX(-300px);
      }
    }

    .vertical-menu:not(.el-menu--collapse).v-leave-active {
      animation: close 0.4s ease-in;
    }
  }

  button.gorizontal-menu__aside-enter {
    @apply px-3;
    max-width: min(35vw, 8rem);
  }
</style>
